var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup58672(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58672",
    "data-name": "Group 58672",
    transform: "translate(-20740 -3390)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4487",
    "data-name": "Ellipse 4487",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(20740 3390)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(20765.238 3418.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66264",
    "data-name": "Path 66264",
    d: "M69.846,66.054H31.763A2.121,2.121,0,0,1,30,62.823L48.859,31.448a2.043,2.043,0,0,1,3.514-.016L71.6,62.807A2.121,2.121,0,0,1,69.846,66.054Z",
    transform: "translate(-28.041 -28.75)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66265",
    "data-name": "Path 66265",
    d: "M42.05,39.226H3.966a3.63,3.63,0,0,1-1.931-.555,3.77,3.77,0,0,1-1.3-1.389A3.856,3.856,0,0,1,.813,33.44L19.669,2.066A3.664,3.664,0,0,1,22.808.26h.017a3.671,3.671,0,0,1,3.138,1.777L45.188,33.412a3.878,3.878,0,0,1,.1,3.855A3.692,3.692,0,0,1,42.05,39.226ZM22.824,3.613h0a.413.413,0,0,0-.367.211L3.6,35.2a.431.431,0,0,0-.009.449.41.41,0,0,0,.378.227H42.05a.412.412,0,0,0,.379-.229.432.432,0,0,0-.012-.45L23.191,3.82A.412.412,0,0,0,22.824,3.613Z",
    transform: "translate(-0.245 -0.246)",
    fill: "#c50f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66266",
    "data-name": "Path 66266",
    d: "M41.8,39H3.721a3.644,3.644,0,0,1-1.939-.555,3.786,3.786,0,0,1-1.307-1.4,3.869,3.869,0,0,1,.08-3.856L19.411,1.813A3.68,3.68,0,0,1,22.562,0h.017a3.68,3.68,0,0,1,3.15,1.785L44.954,33.159a3.891,3.891,0,0,1,.1,3.87A3.707,3.707,0,0,1,41.8,39ZM22.579.029h-.017a3.651,3.651,0,0,0-3.127,1.8L.579,33.2A3.844,3.844,0,0,0,.5,37.029a3.769,3.769,0,0,0,1.3,1.389,3.619,3.619,0,0,0,1.923.548H41.8a3.679,3.679,0,0,0,3.23-1.951,3.864,3.864,0,0,0-.1-3.841L25.7,1.8A3.651,3.651,0,0,0,22.579.029ZM41.8,35.643H3.721a.425.425,0,0,1-.389-.235.444.444,0,0,1,.009-.463L22.2,3.57a.427.427,0,0,1,.379-.218h0a.427.427,0,0,1,.379.214L42.183,34.942a.444.444,0,0,1,.012.464.425.425,0,0,1-.391.237ZM22.576,3.381a.4.4,0,0,0-.354.2L3.366,34.959a.419.419,0,0,0-.009.435.4.4,0,0,0,.365.222H41.8a.4.4,0,0,0,.366-.222.419.419,0,0,0-.012-.437L22.933,3.582a.4.4,0,0,0-.354-.2Z",
    transform: "translate(0.001)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66267",
    "data-name": "Path 66267",
    d: "M69.846,66.054H31.763A2.121,2.121,0,0,1,30,62.823L48.859,31.448a2.043,2.043,0,0,1,3.514-.016L71.6,62.807A2.121,2.121,0,0,1,69.846,66.054Z",
    transform: "translate(-28.041 -28.75)",
    fill: "#c50f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66268",
    "data-name": "Path 66268",
    d: "M69.573,65.823H31.489a2.055,2.055,0,0,1-1.8-1.064,2.148,2.148,0,0,1,.028-2.189L48.573,31.2a2.062,2.062,0,0,1,1.766-1.015h.009a2.061,2.061,0,0,1,1.765,1L71.338,62.554a2.148,2.148,0,0,1,.042,2.2A2.055,2.055,0,0,1,69.573,65.823ZM50.347,30.209h-.009a2.031,2.031,0,0,0-1.741,1L29.742,62.584a2.119,2.119,0,0,0-.028,2.161,2.026,2.026,0,0,0,1.777,1.049H69.573a2.025,2.025,0,0,0,1.782-1.055,2.118,2.118,0,0,0-.042-2.166L52.087,31.195A2.031,2.031,0,0,0,50.347,30.209Z",
    transform: "translate(-27.768 -28.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66269",
    "data-name": "Path 66269",
    d: "M58.189,54.863H20.105a2.709,2.709,0,0,1-2.4-1.444,2.844,2.844,0,0,1,.059-2.854L36.619,19.191a2.722,2.722,0,0,1,2.333-1.341h.012A2.721,2.721,0,0,1,41.3,19.17L60.52,50.544a2.842,2.842,0,0,1,.076,2.862A2.7,2.7,0,0,1,58.189,54.863ZM38.963,19.247h-.007a1.354,1.354,0,0,0-1.174.678L18.927,51.3a1.432,1.432,0,0,0-.029,1.437,1.364,1.364,0,0,0,1.208.725H58.189a1.364,1.364,0,0,0,1.212-.733,1.432,1.432,0,0,0-.039-1.444L40.136,19.913A1.353,1.353,0,0,0,38.963,19.247Z",
    transform: "translate(-16.384 -16.859)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66270",
    "data-name": "Path 66270",
    d: "M365.735,157.58c-1.673,0-2.8,2.378-2.559,4.825l1.5,15c.037.37.513.654,1.061.654s1.024-.284,1.06-.654l1.5-15C368.539,159.958,367.407,157.58,365.735,157.58Z",
    transform: "translate(-342.973 -148.828)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4483",
    "data-name": "Ellipse 4483",
    cx: 1.633,
    cy: 1.633,
    r: 1.633,
    transform: "matrix(0.386, -0.922, 0.922, 0.386, 20.624, 32.3)",
    fill: "#ffafaf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup58672);
export default __webpack_public_path__ + "static/media/group_58672.e5683450fbeaa5cdcc2607ed0d2124fc.svg";
export { ForwardRef as ReactComponent };